/* Lisalva — "Combina bem com" no carrinho (gaveta + página). Sem dependências. */
(function () {
  if (window.__lcuInit) return; window.__lcuInit = true;
  var REC = '/recommendations/products.json';
  var cache = {};
  function money(c) { try { return (c / 100).toLocaleString('pt-PT', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }); } catch (e) { return (c / 100).toFixed(2) + ' €'; } }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]; }); }
  function img(u) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=240'; }
  function recs(pid, intent) {
    var k = pid + ':' + intent;
    if (!cache[k]) cache[k] = fetch(REC + '?product_id=' + pid + '&intent=' + intent + '&limit=6')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; });
    return cache[k];
  }
  function card(p) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
    var single = (p.variants || []).length === 1;
    var url = (p.url || ('/products/' + p.handle)).split('?')[0];
    var was = p.compare_at_price && p.compare_at_price > p.price ? '<s class="lcu__was">' + money(p.compare_at_price) + '</s>' : '';
    var btn = single
      ? '<button type="button" class="lcu__btn" data-lcu-add="' + v.id + '">Adicionar</button>'
      : '<a class="lcu__btn lcu__btn--ghost" href="' + url + '">Escolher</a>';
    return '<div class="lcu__card" data-lcu-pid="' + p.id + '">' +
      '<a class="lcu__thumb" href="' + url + '" tabindex="-1" aria-hidden="true">' + (p.featured_image ? '<img src="' + img(p.featured_image) + '" alt="" width="120" height="150" loading="lazy">' : '') + '</a>' +
      '<a class="lcu__name" href="' + url + '">' + esc(p.title) + '</a>' +
      '<span class="lcu__price"><span class="lcu__now">' + money(p.price) + '</span>' + was + '</span>' + btn + '</div>';
  }
  function update(root, cart) {
    var limit = parseInt(root.getAttribute('data-lcu-limit'), 10) || 4;
    var track = root.querySelector('[data-lcu-track]');
    if (!track) return;
    if (!root.__fallback) root.__fallback = track.innerHTML;
    var inCart = {}, ids = [];
    (cart.items || []).forEach(function (i) { if (!inCart[i.product_id]) { inCart[i.product_id] = 1; ids.push(i.product_id); } });
    if (!ids.length) { root.hidden = true; return; }
    var first = ids.slice(0, 3);
    Promise.all(first.map(function (id) { return recs(id, 'complementary'); })).then(function (lists) {
      var all = [].concat.apply([], lists);
      return all.length >= limit ? all : recs(first[0], 'related').then(function (rel) { return all.concat(rel); });
    }).then(function (all) {
      var seen = {}, out = [];
      all.forEach(function (p) { if (p && p.available && !inCart[p.id] && !seen[p.id]) { seen[p.id] = 1; out.push(p); } });
      if (out.length) { track.innerHTML = out.slice(0, limit).map(card).join(''); }
      else {
        track.innerHTML = root.__fallback;
        Array.prototype.forEach.call(track.querySelectorAll('[data-lcu-pid]'), function (c) { if (inCart[c.getAttribute('data-lcu-pid')]) c.remove(); });
      }
      root.hidden = !track.children.length;
      track.scrollLeft = 0;
    });
  }
  var t;
  function refresh(cart) {
    clearTimeout(t);
    t = setTimeout(function () {
      var p = cart ? Promise.resolve(cart) : fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      p.then(function (c) { Array.prototype.forEach.call(document.querySelectorAll('[data-lcu]'), function (root) { update(root, c); }); }).catch(function () {});
    }, 150);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lcu-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var root = btn.closest('[data-lcu]');
    var onPage = root && root.getAttribute('data-lcu-context') === 'page';
    btn.disabled = true; btn.textContent = 'A adicionar…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-lcu-add'), 10), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); btn.classList.add('is-done'); btn.textContent = 'Adicionado ✓';
        if (onPage) { window.location.reload(); return; }
        document.dispatchEvent(new CustomEvent('cart:build'));
        return fetch('/cart.js').then(function (r2) { return r2.json(); }).then(function (c) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: c } }));
        });
      })
      .catch(function () { btn.disabled = false; btn.classList.remove('is-done'); btn.textContent = 'Adicionar'; });
  });
  ['ajaxProduct:added', 'drawerOpen.CartDrawer'].forEach(function (ev) { document.addEventListener(ev, function () { refresh(); }); });
  document.addEventListener('cart:updated', function (e) { refresh(e.detail && e.detail.cart && e.detail.cart.items ? e.detail.cart : null); });
  // Página do carrinho: calcula logo. Gaveta: só quando abre (poupa pedidos em todas as páginas).
  if (document.querySelector('[data-lcu-context="page"]')) refresh();
})();
